import React, { useMemo } from 'react';
import { Button, ContentFrame, ScreenContainer } from '@pinwheel/origami';
import CircledBang from '../../assets/CircledBang';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useReturnButtonText } from '../../hooks/useReturnButtonText';
import { useOpts } from '../../context';
import { TemplateContinue } from '../../components/TemplateContinue';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
var CircledBangWithProps = function () {
    return React.createElement(CircledBang, { size: 80, color: "#1170FF", secondaryColor: "#CCE0FF" });
};
export default function WizardError() {
    var getLocalizedString = useGetLocalizedString();
    var navigate = useLinkNavigate();
    var returnButtonText = useReturnButtonText();
    var exit = useOpts().exit;
    var exitToBank = useMemo(function () { return (React.createElement(Button, { variant: "ghost", dataTestId: "Exit", onClick: function () {
            return exit();
        } }, returnButtonText)); }, [returnButtonText, exit]);
    return (React.createElement(ScreenContainer, { "data-testid": "Wizard-Error" },
        React.createElement(ContentFrame, null,
            React.createElement(TemplateContinue, { extraControls: exitToBank, Image: CircledBangWithProps, title: getLocalizedString('WIZARD_ERROR'), onContinue: function () {
                    return navigate('/search/search');
                }, buttonLabel: getLocalizedString('CONTINUE_ANYWAY') }))));
}
